import { TrackerEvent } from './tracker-event';
import { idToString, convertMonetaryValueToNumber, createTrackReplayer } from './util';
import { loadScript } from '@fastcampus/browser-util';

export class GroobeeTracker {
  static create(opts, context) {
    return new GroobeeTracker(opts, context);
  }

  constructor({ id, userId }, context) {
    (function (a, i, u, e, o) {
      a[u] =
        a[u] ||
        function () {
          (a[u].q = a[u].q || []).push(arguments);
        };
    })(context, document, 'groobee');
    context.groobee('serviceKey', id);
    context.groobee('siteType', 'custom');

    this.name = 'groobee';
    this.disabled = !id;
    this.id = id;
    this.userId = userId;
    this.groobee = context.groobee;

    if (this.userId) {
      const head = document.querySelector('head');
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'groobee:member_id');
      meta.setAttribute('content', this.userId);
      head.appendChild(meta);
    }

    loadScript('//static.groobee.io/dist/lib/groobee.init.min.js')
      .then(() => {
        this.ready = true;
      })
      .catch((err) => console.error('install err!', err));
  }

  track(event, data) {
    if (!this.ready) {
      if (process.env['NODE_ENV'] !== 'prod') console.error('**ignore** not ready!', event, data);
      const trackReplayer = createTrackReplayer({ target: this, time: 3 });
      trackReplayer(event, data);
      return;
    }
    switch (event) {
      case TrackerEvent.PAGE_VIEW:
        break;
      case TrackerEvent.USER_SIGNUP:
        break;
      case TrackerEvent.USER_LOGIN:
        break;
      case TrackerEvent.FORMAT_VIEW:
        break;
      case TrackerEvent.CATEGORY_VIEW:
        break;
      case TrackerEvent.COURSE_VIEW: {
        const course = data;
        const goods = {
          name: course.title, // 상품명
          code: course.id, // URL에 표시되는 유니크한 상품 코드
          cat: idToString(course.formatId) + '/' + idToString(course.categoryId), // URL에 표시되는 유니크한 상품 카테고리
        };
        this.groobee('goodsInfo', { goods });
        break;
      }
      case TrackerEvent.ENROLLMENT_VIEW: {
        const { product } = data;
        const goods = {
          name: product.title, // 상품명
          code: product.id, // URL에 표시되는 유니크한 상품 코드
          cat: idToString(product.formatId) + '/' + idToString(product.categoryId), // URL에 표시되는 유니크한 상품 카테고리
          amt: convertMonetaryValueToNumber(product.salePrice), // 상품 금액 (현재 판매가 * 수량)
          // cnt: // 수량
        };
        this.groobee('viewCart', { goods });
        break;
      }
      case TrackerEvent.ENROLLMENT_PENDING:
        break;
      case TrackerEvent.TRANSACTION_ORDER: {
        const { product } = data;
        const goods = [
          {
            name: product.title, // 상품명
            code: product.id, // URL에 표시되는 유니크한 상품 코드
            cat: idToString(product.formatId) + '/' + idToString(product.categoryId), // URL에 표시되는 유니크한 상품 카테고리
            amt: convertMonetaryValueToNumber(product.salePrice), // 상품 금액 (현재 판매가 * 수량)
            cnt: product.quantity || 1,
          },
        ];
        this.groobee('order', { goods });
        break;
      }
      case TrackerEvent.TRANSACTION_PAYMENT: {
        const { productSaleInfo, transactionInfo } = data;
        const payload = { goods: [], orderNo: null };

        if (productSaleInfo && productSaleInfo.product && transactionInfo && transactionInfo.transaction) {
          const { amount, quantity, id: transactionId } = transactionInfo.transaction;
          const { title, id: productId, formatId, categoryId } = productSaleInfo.product;
          payload.goods = [
            {
              name: title, // 상품명
              code: productId, // URL에 표시되는 유니크한 상품 코드
              cat: idToString(formatId) + '/' + idToString(categoryId),
              // URL에 표시되는 유니크한 상품 카테고리
              amt: amount * (quantity || 1), // 상품 금액 (현재 판매가 * 수량)
              cnt: quantity || 1, // 수량
            },
          ];
          payload.orderNo = transactionId;
        }

        this.groobee('orderComplete', payload);
        break;
      }
      case TrackerEvent.COMMON: {
        break;
      }
    }
  }
}
